module.exports = "/wwwroot/img/container_page.png?ver=a6b3e0d2";